module.exports = __webpack_public_path__ + "static/media/logo_lvn_white.915277ab.svg";